import { render, staticRenderFns } from "./BaremeHome.vue?vue&type=template&id=46b6ff2a&scoped=true&"
import script from "./BaremeHome.vue?vue&type=script&lang=js&"
export * from "./BaremeHome.vue?vue&type=script&lang=js&"
import style0 from "./BaremeHome.vue?vue&type=style&index=0&id=46b6ff2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b6ff2a",
  null
  
)

export default component.exports